import React from 'react';

const HelperServices = () => {
  const services = [
    {
      icon: '✈️',
      title: 'Airport Check-in Assistance',
      description: 'Help with self-service kiosks, checking bags, printing boarding passes, and communicating with airline staff'
    },
    {
      icon: '🔒',
      title: 'Security Navigation',
      description: 'Guide through TSA/security procedures, help organize carry-on items, and explain what to expect'
    },
    {
      icon: '🚪',
      title: 'Gate Navigation',
      description: 'Find the correct gate by checking departure screens, help with gate changes, and ensure timely boarding'
    },
    {
      icon: '🍽️',
      title: 'Terminal Navigation',
      description: 'Give directions to restaurants, restrooms, shops, and lounges. Help navigate large terminals confidently'
    },
    {
      icon: '💺',
      title: 'In-Flight Check-ins',
      description: 'Touch base a couple of times during the flight to ensure comfort and help with any questions'
    },
    {
      icon: '🗣️',
      title: 'Language Support',
      description: 'Communicate in native language (Hindi, Telugu, Tamil, Gujarati, etc.) for peace of mind'
    }
  ];

  return (
    <div className="py-20 bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
            Complete Journey Support
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From check-in to landing, FlyBuddy helpers provide comprehensive assistance throughout the travel experience
          </p>
        </div>

        <div className="max-w-6xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-xl shadow-sm hover:shadow-lg transition border border-blue-100"
            >
              <div className="text-5xl mb-4">{service.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        {/* <div className="mt-16 bg-white p-8 rounded-2xl max-w-3xl mx-auto shadow-lg border-2 border-blue-200">
          <div className="text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              💝 Show Your Appreciation
            </h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              Helpers volunteer their time to make travel easier for elderly parents. 
              As a token of gratitude, travelers can offer a small gift card after the journey is complete.
            </p>
            <p className="text-gray-600 mt-4 text-sm italic">
              Payment is optional and based on the quality of help received
            </p>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default HelperServices;